<div (click)="show()">
  <span class="textUnderlined">{{params.value}}</span>
</div>